import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 sm:py-24 bg-fog">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden bg-ember-band text-white px-8 py-14 sm:px-14 sm:py-16">
          <div
            className="absolute inset-0 opacity-20 pixel-grid"
            aria-hidden
          />
          <div className="relative max-w-2xl">
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-tight text-balance">
              {t.cta.title}
            </h2>
            <p className="mt-5 text-lg text-white/85 leading-relaxed">{t.cta.body}</p>

            <a
              href="/s"
              className="mt-9 inline-flex items-center gap-2 bg-ember hover:bg-ember-deep text-white px-8 py-4 font-extrabold text-base transition-colors"
            >
              {t.cta.button}
              <ArrowRight className="w-5 h-5" />
            </a>

            <p className="mt-6 text-sm font-semibold text-white/95">{t.cta.priceLine}</p>
            <p className="mt-1 text-sm text-white/75">{t.cta.helpLine}</p>
            <p className="mt-6 text-xs text-white/60 leading-relaxed max-w-xl">{t.cta.legalBox}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
